import {
  loadConnectAndInitialize,
  type StripeConnectInstance,
} from "@stripe/connect-js";

// Single in-flight initialization keyed nowhere because account-session
// secrets are per-user — components mount once per page mount and Stripe
// refreshes the secret via the fetchClientSecret callback.
export function initStoopConnect(): StripeConnectInstance {
  const publishableKey = import.meta.env.VITE_STRIPE_PUBLIC_KEY as string | undefined;
  if (!publishableKey) {
    throw new Error("Missing VITE_STRIPE_PUBLIC_KEY — Stripe components can't load");
  }
  return loadConnectAndInitialize({
    publishableKey,
    fetchClientSecret: async () => {
      const res = await fetch("/api/seller/stripe-account-session", {
        method: "POST",
        credentials: "include",
      });
      if (!res.ok) {
        const body = await res.text().catch(() => "");
        throw new Error(body || `Stripe session request failed (${res.status})`);
      }
      const { clientSecret } = await res.json();
      if (!clientSecret) throw new Error("No clientSecret in account-session response");
      return clientSecret as string;
    },
    appearance: {
      overlays: "dialog",
      variables: {
        colorPrimary: "#A44A2A",
        colorBackground: "#F7F1E6",
        colorText: "#2D2419",
        colorSecondaryText: "#6B5E4F",
        colorDanger: "#C73B25",
        actionPrimaryColorText: "#FCF6EC",
        actionSecondaryColorText: "#A44A2A",
        offsetBackgroundColor: "#FFFFFF",
        formBackgroundColor: "#FFFFFF",
        fontFamily: '"Avenir Next Rounded", "Trebuchet MS", "Segoe UI", sans-serif',
        fontSizeBase: "16px",
        borderRadius: "12px",
        buttonBorderRadius: "12px",
        formBorderRadius: "10px",
        badgeBorderRadius: "8px",
        spacingUnit: "9px",
      },
    },
  });
}
